import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';

import { AuthService } from './auth.service';
import {CrudService} from '../services/crud/crud.service';
import {AngularFireAuth} from '@angular/fire/auth';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private crudService: CrudService<any, any>, private router: Router, private afAuth: AngularFireAuth, ) {}
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot):
   boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {

    return new Promise((resolve, reject) => {
      this.afAuth.onAuthStateChanged(user => {
        if (user) {
          user.getIdTokenResult().then(idTokenResult => {
            if (idTokenResult.claims.expert) {
              if (user.emailVerified === false) {
                this.router.navigate(['/pending-account']).then();
                resolve(true);
              } else {
                if (route.data.role === 'ROLE_EXPERT') {
                  resolve(true);
                } else {
                  this.router.navigate(['/signin']).then();
                  resolve(false);
                }
              }

            } else if (idTokenResult.claims.admin) {
              if (user.emailVerified === false) {
                this.router.navigate(['/pending-account']).then();
                resolve(true);
               } else {
                if (route.data.role === 'ROLE_ADMIN') {
                  resolve(true);
                } else {
                  this.router.navigate(['/signin']).then();
                  resolve(false);
                }
               }

            } else if (idTokenResult.claims.subscriber) {
              if (route.data.role === 'ROLE_SUBSCRIBER') {
                resolve(true);
              } else {
                this.router.navigate(['/signin']).then();
                resolve(false);
              }
            } else {
              this.router.navigate(['/signin']).then();
              resolve(false);            }
          });
        } else {
          this.router.navigate(['/signin']).then();
          resolve(false);
        }
      }).then(() => {
      }).catch(() => {
        console.log('not found');
        resolve(false);
      });
    });
  }
}
